import { useTranslations } from "@jugl-web/utils";
import { DragDropContext, DropResult, Droppable } from "react-beautiful-dnd";
import { AppMenuItem } from "@jugl-web/rest-api";
import { SIDEBAR_MAX_VISIBLE_ITEMS } from "../../../../consts";
import { DraggableItem } from "./components/DraggableItem/DraggableItem";
// import { PinButton } from "./components/PinButton/PinButton";
// import { ReactComponent as HomePageIcon } from "./assets/home.svg";
// import { ReactComponent as FirstSlotIcon } from "./assets/first-slot.svg";
import { useHomeSidebar } from "../../../../hooks/useHomeSidebar";
import { SidebarToolItem } from "./components/SidebarToolItem";

export const MenuSetter = ({
  pinnedTools,
  onPinClick,
  onDragEnd,
}: {
  pinnedTools: AppMenuItem[];
  onPinClick: (e: React.SyntheticEvent, itemKey: AppMenuItem) => void;
  onDragEnd: (result: DropResult) => void;
}) => {
  const { t } = useTranslations();
  const { allItems } = useHomeSidebar();

  const pinnedToolsList = pinnedTools
    .map((itemKey) => allItems.find((tool) => tool.itemKey === itemKey))
    .filter(Boolean);

  const unPinnedToolsList = allItems.filter(
    (tool) => tool.itemKey && !pinnedTools.includes(tool.itemKey)
  );

  const hasOverflowItems = allItems.length > SIDEBAR_MAX_VISIBLE_ITEMS;

  return (
    <div className="font-secondary flex h-full w-full flex-col items-start justify-start">
      <div className="flex flex-col gap-2">
        <div className="text-dark pt-2 text-2xl font-medium">
          {t({
            id: "personalize-menu-dialog.menu-setter.title",
            defaultMessage: "Personalise menu items",
          })}
        </div>
        <div className="text-dark-700 text-sm">
          {hasOverflowItems
            ? t(
                {
                  id: "personalize-menu-dialog.menu-setter.description-count",
                  defaultMessage:
                    "Select up to {count} items that you would like to pin in the side menu 📌",
                },
                { count: SIDEBAR_MAX_VISIBLE_ITEMS }
              )
            : t({
                id: "personalize-menu-dialog.menu-setter.description",
                defaultMessage:
                  "Select items that you would like to pin in the side menu 📌",
              })}
        </div>
      </div>
      <div className="jugl__custom-scrollbar w-full overflow-y-auto">
        <div className="text-dark-700 flex w-full justify-between px-2 pt-10 pb-2 text-xs">
          {t({
            id: "personalize-menu-dialog.menu-setter.pinned-items-section-title",
            defaultMessage: "Pinned to side menu",
          })}
          {hasOverflowItems && (
            <div>
              {pinnedTools.length}/{SIDEBAR_MAX_VISIBLE_ITEMS}
            </div>
          )}
        </div>
        {/* <div className="pr-1">
          <div className="bg-grey-100 font-secondary text-dark relative flex h-[41px] w-full items-center gap-2 rounded-lg pl-2 pr-4 text-sm">
            <FirstSlotIcon />
            <HomePageIcon />
            {t({
              id: "personalize-menu-dialog.menu-setter.home-page",
              defaultMessage: "Home page",
            })}
            <PinButton
              onClick={() => {}}
              isPinned
              className="absolute right-2"
              isHomePage
            />
          </div>
        </div> */}
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="pinned-features">
            {(provided) => (
              <div
                ref={provided.innerRef}
                className="flex w-full flex-col gap-1 pt-1 pr-1"
                style={{
                  minHeight: `${pinnedTools.length * 45}px`,
                }}
                {...provided.droppableProps}
              >
                {pinnedToolsList.map(
                  (tool, index) =>
                    tool && (
                      <DraggableItem
                        key={tool.itemKey}
                        id={tool.title}
                        index={index}
                      >
                        <SidebarToolItem
                          title={tool.title}
                          icon={tool.dialogIcon}
                          isPinned
                          onPinClick={(e) =>
                            tool.itemKey && onPinClick(e, tool.itemKey)
                          }
                          isDraggable
                        />
                      </DraggableItem>
                    )
                )}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        {!!unPinnedToolsList.length && (
          <>
            <div className="text-dark-700 flex w-full justify-between px-2 pt-10 pb-2 text-xs">
              {t({
                id: "personalize-menu-dialog.menu-setter.unpinned-items-section-title",
                defaultMessage: "Shown under “More” menu",
              })}
            </div>
            <div className="flex w-full flex-col gap-1 pr-1">
              {unPinnedToolsList.map((tool) => (
                <SidebarToolItem
                  key={tool.title}
                  title={tool.title}
                  icon={tool.dialogIcon}
                  isPinned={false}
                  isAtLimit={pinnedTools.length >= SIDEBAR_MAX_VISIBLE_ITEMS}
                  onPinClick={(e) =>
                    tool.itemKey && onPinClick(e, tool.itemKey)
                  }
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
